import uiTagIndicator from './tag-indicator/index.vue'
import uiTagLine from './tag-line/index.vue'
import uiTagIcon from './tag-icon/index.vue'
import uiAddTagInput from './add-tag-input/index.vue'

export {
    uiTagIndicator,
    uiTagLine,
    uiTagIcon,
    uiAddTagInput
}